module.exports = __webpack_public_path__ + "img/PH.31df78c6.svg";